var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 63.5516C32.64 63.5516 31.3083 63.2399 30.2033 62.6449L10.37 51.6232C8.07501 50.3482 6.375 47.4299 6.375 44.8232V23.1766C6.375 20.5699 8.10337 17.6232 10.3984 16.3766L30.2317 5.3549C32.385 4.1649 35.6433 4.1649 37.7967 5.3549L57.63 16.3766C59.925 17.6516 61.625 20.5699 61.625 23.1766V44.8516C61.625 47.4582 59.8966 50.4049 57.6016 51.6516L37.7683 62.6732C36.72 63.2682 35.36 63.5516 34 63.5516ZM34 8.69824C33.3483 8.69824 32.725 8.81157 32.2717 9.06657L12.4384 20.0882C11.5034 20.5982 10.625 22.0999 10.625 23.1766V44.8516C10.625 45.9282 11.5034 47.4299 12.4384 47.9399L32.2717 58.9616C33.15 59.4432 34.85 59.4432 35.7 58.9616L55.5333 47.9399C56.4683 47.4299 57.3466 45.9282 57.3466 44.8516V23.1766C57.3466 22.0999 56.4683 20.5982 55.5333 20.0882L35.7 9.06657C35.275 8.81157 34.6517 8.69824 34 8.69824Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainLink);
export default __webpack_public_path__ + "static/media/chain-link.fe6977efb69dca2edf2e5ad4bb751ec8.svg";
export { ForwardRef as ReactComponent };